import { createContext } from "react"

export interface ITabManagerContext {
  isActiveTab: boolean
  isTabLocked: boolean
  reloadPage: () => void
}

export const TabManagerContext = createContext<ITabManagerContext>({
  isActiveTab: true,
  isTabLocked: false,
  reloadPage: () => {}
})
